import { Grid2, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router';

import { colors } from 'src/global/styles/colors';
import { useProjectDashboardContext } from 'src/hooks/useProjectDashboardContext';

import FundDistributionChart from '../components/FundDistributionChart';
import FundingDistributionTable from '../components/FundingDistributionTable';
import KPICards from '../components/KPICards';
import LFGRevenueChart from '../components/LFGRevenueChart';
import OTCSalesSection from '../components/OTCSalesSection';
import RoleListTable from '../components/RoleListTable';
import TotalSalesChart from '../components/TotalSalesChart';

const Analytics = () => {
  const { id: projectId } = useParams();

  const { address, network } = useProjectDashboardContext();

  if (!projectId || !address || !network) {
    return (
      <Stack width={'100%'} height={'400px'} justifyContent={'center'} alignItems={'center'}>
        <Typography color={colors.neutral90}>Loading project dashboard...</Typography>
      </Stack>
    );
  }

  return (
    <Stack flex={1} height={'100%'} width={'100%'} spacing={3} paddingY={2}>
      {/* Page Header */}
      <Stack spacing={2} mb={8}>
        <Typography
          variant='h4'
          component='h1'
          sx={{
            color: colors.white,
            fontWeight: 700,
            fontSize: '32px',
            lineHeight: '38px',
            textAlign: 'center',
          }}>
          PROJECT DASHBOARD
        </Typography>

        {/* Breadcrumb */}
        {/* <Stack direction='row' spacing={1} alignItems='center' justifyContent='center'>
          <Typography sx={{ color: colors.white, fontSize: '14px' }}>Node Sale</Typography>
          <Typography sx={{ color: colors.white, fontSize: '14px' }}>/</Typography>
          <Typography sx={{ color: colors.white, fontSize: '14px' }}>Project Dashboard</Typography>
          <Typography sx={{ color: colors.white, fontSize: '14px' }}>/</Typography>
          <Typography sx={{ color: colors.neutral90, fontSize: '14px' }}>
            {projectId ? `${projectId.slice(0, 6)}...${projectId.slice(-4)}` : 'Project'}
          </Typography>
        </Stack> */}
      </Stack>

      {/* Main Content */}
      <Stack spacing={7} width='100%' margin='0 auto'>
        {/* Top Section: KPI Cards and Charts */}
        <Stack spacing={3}>
          {/* KPI Cards Row */}
          <KPICards />

          {/* Charts Row */}
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12, lg: 12 }}>
              <TotalSalesChart />
            </Grid2>
            <Grid2 size={{ xs: 12, lg: 12 }}>
              <FundingDistributionTable />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <Grid2 container spacing={3}>
                <Grid2 size={{ xs: 12, lg: 6 }}>
                  <FundDistributionChart />
                </Grid2>
                <Grid2 size={{ xs: 12, lg: 6 }}>
                  <LFGRevenueChart />
                </Grid2>
              </Grid2>
            </Grid2>
            <Grid2 size={{ xs: 12, lg: 12 }}>
              <RoleListTable />
            </Grid2>
            <Grid2 size={{ xs: 12, lg: 12 }} marginTop={3}>
              <OTCSalesSection />
            </Grid2>
          </Grid2>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Analytics;
